export default __webpack_public_path__ + "static/media/generar-orden.6bf4debf.svg";